import axios from 'axios';

const instance = axios.create({
	// baseURL: 'https://react-burger-builder-1cc64.firebaseio.com/',
	baseURL: 'https://fathomless-basin-72027.herokuapp.com/',
});

export default instance;
